<template>
  <div>
    <iframe style="width: 100%; height: 100%" :src="src"> </iframe>
  </div>
</template>

<script>
import base from "@/api/httpApi/base";
export default {
  computed: {
    src() {
      return base.url + "/hangfire";
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/AdminManage/hangfire.vue